import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Fetch } from '../fetch.class';
import ClipboardJS from 'clipboard';

export class Page {

    constructor() {

        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;


        // --- Formulartitel

        // Elemente
        this.$btnEditTitle = document.querySelector('button.title');
        this.$inputEditTitle = document.querySelector('#modal-edit-title input[name=title]');
        this.$displayTitle = document.querySelector('#value_title');
        this.$formEditTitle = document.querySelector('#modal-edit-title form');
        this.$errorboxEditTitle = document.querySelector('#modal-edit-title .errorbox');

        // Modal
        this.modalEditTitle = new Modal('#modal-edit-title');

        // Modaldialog öffnen
        this.$btnEditTitle.addEventListener('click', event => {

            // aktuellen Titel in Eingabe übernehmen
            this.$inputEditTitle.value = this.$displayTitle.textContent;

            // Fehlermeldung ausblenden
            this.$errorboxEditTitle.classList.add('hidden');

            // Modal öffnen
            this.modalEditTitle.show();
        });

        // Speicherung
        this.$formEditTitle.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("title", this.$inputEditTitle.value);

            // Fehler ausblenden
            this.$errorboxEditTitle.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('form', 'save_formtitle'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditTitle.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayTitle.textContent = this.$inputEditTitle.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditTitle.querySelector('.cont').textContent = error.message;
                this.$errorboxEditTitle.classList.remove('hidden');

                // Fokus auf Eingabe
                this.$inputEditTitle.focus();
            });
        });


        // --- Website-Adresse

        // Elemente
        this.$btnEditSiteurl = document.querySelector('button.siteurl');
        this.$inputEditSiteurl = document.querySelector('#modal-edit-siteurl input[name=site_url]');
        this.$displaySiteurl = document.querySelector('#value_siteurl');
        this.$displaySiteurlEmpty = document.querySelector('#value_siteurl_empty');
        this.$formEditSiteurl = document.querySelector('#modal-edit-siteurl form');
        this.$errorboxEditSiteurl = document.querySelector('#modal-edit-siteurl .errorbox');

        // Modal
        this.modalEditSiteurl = new Modal('#modal-edit-siteurl');

        // Modaldialog öffnen
        this.$btnEditSiteurl.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditSiteurl.classList.add('hidden');

            // Modal öffnen
            this.modalEditSiteurl.show();
        });

        // Speicherung
        this.$formEditSiteurl.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("site_url", this.$inputEditSiteurl.value);

            // Fehler ausblenden
            this.$errorboxEditSiteurl.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('form', 'save_siteurl'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditSiteurl.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                if(response.site_url_view == '') {
                    this.$displaySiteurl.classList.add('hidden');
                    this.$displaySiteurlEmpty.classList.remove('hidden');
                }
                else {
                    this.$displaySiteurl.classList.remove('hidden');
                    this.$displaySiteurlEmpty.classList.add('hidden');
                    this.$displaySiteurl.textContent = response.site_url_view;
                }
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditSiteurl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditSiteurl.classList.remove('hidden');

                // Fokus auf Eingabe
                this.$inputEditSiteurl.focus();
            });
        });


        // --- Erfolgsseite

        // Elemente
        this.$btnEditNexturl = document.querySelector('button.nexturl');
        this.$inputEditNexturl = document.querySelector('#modal-edit-nexturl input[name=returnaddress]');
        this.$displayNexturl = document.querySelector('#value_nexturl');
        this.$displayNexturlEmpty = document.querySelector('#value_nexturl_empty');
        this.$formEditNexturl = document.querySelector('#modal-edit-nexturl form');
        this.$errorboxEditNexturl = document.querySelector('#modal-edit-nexturl .errorbox');

        // Modal
        this.modalEditNexturl = new Modal('#modal-edit-nexturl');

        // Modaldialog öffnen
        this.$btnEditNexturl.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditNexturl.classList.add('hidden');

            // Modal öffnen
            this.modalEditNexturl.show();
        });

        // Speicherung
        this.$formEditNexturl.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("next_url", this.$inputEditNexturl.value);

            // Fehler ausblenden
            this.$errorboxEditNexturl.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('form', 'save_nexturl'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditNexturl.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                if(response.next_url_view == '') {
                    this.$displayNexturl.classList.add('hidden');
                    this.$displayNexturlEmpty.classList.remove('hidden');
                }
                else {
                    this.$displayNexturl.classList.remove('hidden');
                    this.$displayNexturlEmpty.classList.add('hidden');
                    this.$displayNexturl.textContent = response.next_url_view;
                }
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditNexturl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditNexturl.classList.remove('hidden');

                // Fokus auf Eingabe
                this.$inputEditNexturl.focus();
            });
        });


        // --- Sprache

        // Elemente
        this.$btnEditLang = document.querySelector('button.lang');
        this.$inputEditLang = document.querySelector('#modal-edit-lang select[name=lang]');
        this.$displayLang = document.querySelector('#value_lang');
        this.$formEditLang = document.querySelector('#modal-edit-lang form');
        this.$errorboxEditLang = document.querySelector('#modal-edit-lang .errorbox');

        // Modal
        this.modalEditLang = new Modal('#modal-edit-lang');

        // Modaldialog öffnen
        this.$btnEditLang.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditLang.classList.add('hidden');

            // Modal öffnen
            this.modalEditLang.show();
        });

        // Speicherung
        this.$formEditLang.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("form_code", this.form_code);
            data.append("lang", this.$inputEditLang.value);

            // Fehler ausblenden
            this.$errorboxEditNexturl.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('form', 'save_lang'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditLang.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayLang.textContent = response.lang_name;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditNexturl.querySelector('.cont').textContent = error.message;
                this.$errorboxEditNexturl.classList.remove('hidden');

                // Fokus auf Auswahl
                this.$inputEditLang.focus();
            });
        });


        // --- API Key

        // Button Kopieren
        const $btnsCopy = document.querySelectorAll('button[data-clipboard-text]');
        const codeClipboard = new ClipboardJS($btnsCopy);
        codeClipboard.on('success', function(e) {

            // Erfolgsmeldung
            const msg = e.trigger.getAttribute('data-clipboard-success');
            new Notification().success(msg);
        });

        // --- Formular löschen

        // Elemente
        this.$btnDelete = document.querySelector('#modal-delete button.delete');

        // Modal
        this.modalDelete = new Modal('#modal-delete');

        // Löschung ausführen
        this.$btnDelete.addEventListener('click', event => {

            const data = new FormData();
            data.append("form_code", this.form_code);

            // Meldungen ausblenden
            new Notification().hideAll();

            // Senden
            new Fetch().post(App.getUrl('form', 'delete'), data)
            .then(response => {

                // Weiterleitung zu Formularübersicht
                App.goto('forms');
            })
            .catch(error => {

                // Modal schliessen
                this.modalDelete.close();

                // Fehlermeldung anzeigen
                new Notification().error(error.message);
            });
        });
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-settings')) {
        new Page();
    }
});